import { render, staticRenderFns } from "./BatchCreateList.vue?vue&type=template&id=6dcfcf6c"
import script from "./BatchCreateList.vue?vue&type=script&lang=js"
export * from "./BatchCreateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports